import moment from 'moment';
export const MAX_MINUTES_IN_CURRENT_HOUR = 59;
// case 23h OR 23h59
export const getNextHourOrEndOfDay = (date: moment) => {
  const nextHour = date.clone().add(1, 'hour').startOf('hour');
  return nextHour.isSame(date, 'day') ? nextHour : date.clone().endOf('day');
};
// calculate the range of time graduations and steps number for marks
export const getRangeTimeGraduations = ({
  startTime,
  endTime,
}: {
  startTime: moment$Moment;
  endTime: moment$Moment;
}) => {
  const graduations = [];
  const numHours = endTime.diff(startTime, 'hours');

  // Iterate through the time range, incrementing by one hour
  for (let i = 0; i <= numHours; i++) {
    graduations.push(startTime.clone().add(i, 'hours').format('HH[h]'));
  }

  // add the last graduation
  // it's the next hour or the end of the day
  const lastGraduation = getNextHourOrEndOfDay(startTime.clone().add(numHours, 'hours'));
  const timeFormat = lastGraduation.minutes() === MAX_MINUTES_IN_CURRENT_HOUR ? 'HH[h]mm' : 'HH[h]';
  graduations.push(lastGraduation.format(timeFormat));
  // Display the graduations
  const stepsNumber = graduations.length;
  return {
    graduations,
    stepsNumber,
  };
};
